import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFacility } from '../context/FacilityContext';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ userForbidden, children }) => {
  const { claims, currentUser, userLoading, userVerified } = useAuth();
  const { facilityId, setFacilityId } = useFacility();
  let navigate = useNavigate();

  useEffect(() => {
    const hasRequiredClaims = () => {
      if ('superadmin' in claims && claims.superadmin) {
        return true;
      }

      if ('admin' in claims && claims.admin) {
        if ('facilities' in claims) {
          if (!claims.facilities.includes(facilityId)) {
            // we will not kick admin to front page, but to some allowed facility
            if (claims.facilities.length > 0) {
              setFacilityId(claims.facilities[0]);
              return true;
            }
            return false;
          } else {
            return true;
          }
        }
        return false;
      }
      if ('staff' in claims && claims.staff) {
        if ('facilities' in claims) {
          if (!claims.facilities.includes(facilityId)) {
            if (claims.facilities.length > 0) {
              setFacilityId(claims.facilities[0]);
              return true;
            }
            return false;
          } else {
            return true;
          }
        }
        return false;
      }

      if (!userForbidden) {
        return true;
      }

      return false;
    };

    if (!userLoading) {
      if (!currentUser || !userVerified) {
        console.error('User not authenticated');
        navigate('/login');
      } else if (!hasRequiredClaims()) {
        console.error('Forbidden');
        navigate('/');
      }
    }
  }, [
    userLoading,
    currentUser,
    userVerified,
    claims,
    facilityId,
    navigate,
    setFacilityId,
    userForbidden,
  ]);

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  userForbidden: PropTypes.bool.isRequired,
};

export default ProtectedRoute;
